module.exports = __webpack_public_path__ + "static/media/take-challenge-popup-male-image.bc07639b.png";